module.exports = __webpack_public_path__ + "static/media/smileyAnonymous.e16bcba9.svg";